import * as React from 'react';
import {NavigateParams} from '../services/Navigator';
import { MainStyle } from '../assets/styles/MainStyle';
import { View,ScrollView, TouchableOpacity, Image, Text, Linking, Alert} from 'react-native';
import NavBar from '../components/NavBar';
import pix_icon from '../assets/images/icons/pix.png';
import whatsapp_icon from '../assets/images/icons/whatsapp.png';
import lupa_icon from '../assets/images/icons/magnifying-glass-solid.png';
import ModalOrder from '../components/ModalOrder';
import { getData } from '../services/StorageService';
import { getClientPendingOrders } from '../services/ApiServices';
export default class PendingPayment extends React.Component {
    constructor(props) {
        super(props);
        const styles = MainStyle();
        this.state = {
            redirect: {status: false, value: '/', params: null},
            styles : styles,
            modalOpenend: false,
            user: {},
            systemColor: 'white',
            currentUrl: "",
            currentSystem: "",
            orders: [],
            modalOrder: {cartelas: []},
            isLoading : false
        }
    }

    componentDidMount(){
        this.setState({isLoading : true});
        getData("current_system_color").then(res => this.setState({systemColor : res}))
        this.initializeDataState().then(res => {
            getClientPendingOrders(res.url, res.user._id).then(res => {
                this.setState({orders : Array.isArray(res)? res : []});
                this.setState({isLoading : false});
            });
        })
    }

    getFullSystemName(){
        return this.state.currentSystem == "cf"?  "CartelaFlash" : this.state.currentSystem == "fd"? "FlashDay" : "Sorteflash"
    }

    async initializeDataState(){
        let url = await getData("current_url");
        let sys = await getData("current_system");
        this.setState({currentUrl: url, currentSystem: sys})
            
        let user = await getData(sys+"_user");
        this.setState({user : JSON.parse(user)});
        return {url, user: JSON.parse(user)};
    }
    
    handleModalOrder(){
        this.setState({modalOpenend : !this.state.modalOpenend})
    }

    
    openURL = async (url) => {
        const supported = await Linking.canOpenURL(url);
        if (supported) {
          await Linking.openURL(url);
        } else {
          Alert.alert(`Don't know how to open this URL: ${url}`);
        }
    }

    render() {
        return (
            <NavBar navigation={this.props.navigation}  isLoading={this.state.isLoading} >
            {this.state.redirect.status? <NavigateParams navigation={this.props.navigation} screen={this.state.redirect.value} params={this.state.redirect.params}></NavigateParams> : <Text></Text>}
                {this.state.modalOpenend? <ModalOrder modalOrder={this.state.modalOrder} onPress={() => this.handleModalOrder()} /> : <Text></Text>}
                <View style={{height:40, ...this.state.styles.row, backgroundColor : this.state.systemColor, ...this.state.styles.justifyCenter, ...this.state.styles.alignCenter}}>
                    <Text  style={{...this.state.styles.bold, ...this.state.styles.fs14, ...this.state.styles.cLight}}>Cartelas pendentes</Text>
                </View>
                <ScrollView>
                <View style={{width: '100%', paddingLeft: 8, paddingRight: 8, ...this.state.styles.col}}>
                    {this.state.orders.map(order => 
                        <View style={{...this.state.styles.mt8, width: '100%',  height: 40, ...this.state.styles.myShadow, ...this.state.styles.row, ...this.state.styles.alignCenter}}>
                            <TouchableOpacity onPressIn={() => {this.handleModalOrder(); this.setState({modalOrder: order})}}>
                                <Image source={lupa_icon} style={{width : 18, height: 18, marginLeft: 8}} /> 
                            </TouchableOpacity>
                                <Text style={{marginLeft: 8}}>{`${order.cartelas[0].data.split('-')[2]+'-'+order.cartelas[0].data.split('-')[1]+'-'+order.cartelas[0].data.split('-')[0]} - Pedido: ${order.codigo} - Cartelas: ${order.cartelas.length}`}</Text>
                            {order.codigoCopiaCola != ""? 
                                <TouchableOpacity onPressIn={() => this.setState({redirect : {status: true, value: 'PixPayment', params: {order : order}}})}> 
                                    <Image source={pix_icon} style={{width : 18, height: 18, marginLeft: 8}} /> 
                                </TouchableOpacity>
                            : <Text></Text>}

                            <TouchableOpacity onPressIn={() => this.openURL(`https://api.whatsapp.com/send?text=${this.getFullSystemName()}: Pedido: ` + order.codigo + ' Valor: R$:' + order.cartelas.length * parseFloat(order.cartelas[0].valor).toFixed(2) + ' Cliente: ' + order.clienteId.nome)}>
                                <Image source={whatsapp_icon} style={{width : 18, height: 18, marginLeft: 8}} /> 
                            </TouchableOpacity>
                        </View> 
                        )}
                </View>
                </ScrollView>
            </NavBar>
            )
    }
}
